import * as React from 'react';

const triangleIcon = (<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.66406 1.20117L5.16406 4.20117L8.66406 1.20117" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  );

export default triangleIcon;
